export default __webpack_public_path__ + "1c88119fe4722550cd5f161c7dc39b87.svg";